import defaultConfig from "@/configs/default.config"
import { GuidClass } from "./guid"
import dayjs from 'dayjs'

import * as t from 'io-ts'
import * as E from 'fp-ts/Either'

/**
 * 设置浏览器标题
 * @param title 
 */
export function setDocumentTitle(title: string){
  document.title = title
  const ua = navigator.userAgent
  // eslint-disable-next-line
  const regex = /\bMicroMessenger\/([\d\.]+)/
  if (regex.test(ua) && /ip(hone|od|ad)/i.test(ua)) {
    const i = document.createElement('iframe')
    i.src = '/favicon.ico'
    i.style.display = 'none'
    i.onload = function () {
      setTimeout(function () {
        i.remove()
      }, 9)
    }
    document.body.appendChild(i)
  }
}

/**
 * 数据转成tree结构
 * @param data 
 * @param parentId 
 * @returns 
 */
export function dataToPromiseTree (data: any[], parentId: number) {
  const len = data.length
  const tree = []
  for (let i = 0; i < len; i++) {
    if (data[i].parentId === parentId) {
      const obj = {
        ...data[i]
      }
      obj.actionList = dataToPromiseTree(data, data[i].id)
      tree.push(obj)
    }
  }
  return tree
}

/**
 * 判断是否有对应的权限
 * @param permission 
 * @param route 
 * @returns 
 */
export function hasPermission (permission: any, route: any) {
  if (defaultConfig.check_auth === 'false') {
    return true
  }

  if(route.meta && route.meta.anyAuth){
    return true
  }

  if (route.meta && route.meta.permission) {
    let flag = false
    for (let i = 0, len = permission.length; i < len; i++) {
      flag = route.meta.permission.includes(permission[i].sign)
      if (flag) {
        return true
      }
    }
    return false
  }
  return true
}

/**
 * 过滤权限菜单
 * @param routerMap 
 * @param roles 
 * @returns 
 */
export function filterAsyncRouter (routerMap:any, roles:any) {
  const accessedRouters = routerMap.filter((route: any) => {
    if (hasPermission(roles, route)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, roles)
      }
      return true
    }
    return false
  })
  return accessedRouters
}

/**
 * 绑定事件
 * @param obj 事件对象
 * @param sType 事件名称
 * @param fn 回调函数
 */
export function addEvent (obj: any, sType: string, fn: any) {
  if (obj.addEventListener) {
    obj.addEventListener(sType, fn, false)
  } else {
    obj.attachEvent('on' + sType, fn)
  }
}

/**
 * 移除事件
 * @param obj 事件对象
 * @param sType 事件名称
 * @param fn 回调函数
 */
export function removeEvent (obj: any, sType: string, fn: any) {
  if (obj.removeEventListener) {
    obj.removeEventListener(sType, fn, false)
  } else {
    obj.detachEvent('on' + sType, fn)
  }
}

/**
 * 当前事件
 * @param ev 事件
 * @returns 
 */
export function prEvent (ev: any) {
  const oEvent = ev || window.event
  if (oEvent.preventDefault) {
    oEvent.preventDefault()
  }
  return oEvent
}

/**
 * 添加滚轮事件
 * @param obj 绑定事件对象
 * @param callback 回调函数
 */
export function addWheelEvent (obj:any, fn:any) {
  if (window.navigator.userAgent.toLowerCase().indexOf('firefox') !== -1) {
    addEvent(obj, 'DOMMouseScroll', wheel)
  } else {
    addEvent(obj, 'mousewheel', wheel)
  }
  function wheel (ev: any) {
    const oEvent = prEvent(ev)
    const delta = oEvent.detail ? oEvent.detail > 0 : oEvent.wheelDelta < 0
    fn && fn.call(oEvent, delta)
    return false
  }
}

/**
 * 随机密码
 * @param length 长度
 * @returns 
 */
export function generateRandomPassword(length: number) {
  const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let password = "";
  for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      password += charset[randomIndex];
  }
  return password;
}

/**
 * 生成guid
 * @returns 
 */
export function getNewGuid () {
  return new GuidClass().newGUID()
}
/**
 * 获取当天开始和结束的时间点
 * @returns Array
 */
export function dateBeginEndTime(){
  return [dayjs(dayjs().format('YYYY-MM-DD 00:00:00')), dayjs(dayjs().format('YYYY-MM-DD 23:59:59'))]
}

/**
 * 根据字符串计算长度，用于表格宽度计算
 * @param text 
 * @returns 
 */
export function estimateWidth(text: string) {
  let width = 0;
  for (const char of text) {
      if (/[a-zA-Z0-9]/.test(char)) {
          width += 17;
      } else {
          width += 22;
      }
  }
  if(width < 70) width += 20
  return width;
}

/**
 * 字符串转16进制hex
 * @param str 
 * @returns 
 */
export function stringToHex(str: string) {
  const hexs = []
  for (let i = 0; i < str.length; i++) {
      const code = str.charCodeAt(i).toString(16).padStart(2, '0')
      hexs.push('0x' + code)
  }
  return `{${hexs.join(',')}}`
}

export function guidToHex(guid: string){
  const guidArr = guid.split('-').join('').match(/.{1,2}/g)
  if(guidArr && guidArr.length > 0){
    const hexArray = guidArr.map(byte => `0x${parseInt(byte, 16).toString(16).padStart(2, '0').toUpperCase()}`)
    return `{${hexArray.join(',')}}`
  }
}

export function calculateAngle(x1: number, y1: number, x2: number, y2: number) {
  // console.log(x1,y1,x2,y2)
  // 计算斜率 m
  const slope = x2 - x1 === 0 ? 0 : (y2 - y1) / (x2 - x1)
    
  // 计算与x轴的夹角（弧度）
  const angleInRadians = Math.atan(slope)

  // 转换为度数
  const angleWithXAxisInDegrees = angleInRadians * 180 / Math.PI

  // 计算与y轴的夹角
  const angleWithYAxisInDegrees = 90 - Math.abs(angleWithXAxisInDegrees)

  // 计算方向
  const deltaX = x2 - x1
  const deltaY = y2 - y1

  if (deltaX > 0 && deltaY > 0) {
      return angleWithYAxisInDegrees
  } else if (deltaX < 0 && deltaY > 0) {
      return 180 - angleWithYAxisInDegrees
  } else if (deltaX < 0 && deltaY < 0) {
      return 180 + angleWithYAxisInDegrees
  } else if (deltaX > 0 && deltaY < 0) {
      return 360 - angleWithYAxisInDegrees
  } else if (deltaX === 0 && deltaY > 0) {
      return 0 //'y轴正方向' // 纯上方向
  } else if (deltaX === 0 && deltaY < 0) {
      return 180 //'y轴负方向' // 纯下方向
  } else if (deltaX > 0 && deltaY === 0) {
      return 90 //'x轴正方向' // 纯右方向
  } else if (deltaX < 0 && deltaY === 0) {
      return 270 //'x轴负方向' // 纯左方向
  } else {
      return 0 //'两个点重合' // 如果两个点重合
  }
}

// 定义接口对应的 Codec
const BatchAddUserDataTypeArgsCodec = t.type({
  name: t.string,
  type: t.number,
  direction: t.number,
  dataLen: t.number,
  tag: t.string,
  no: t.number,
  columnWidth: t.number,
  remark: t.string,
})
// 导出接口类型
export type BatchAddUserDataTypeArgs = t.TypeOf<typeof BatchAddUserDataTypeArgsCodec>
// 定义数组 Codec
const BatchAddUserDataTypeArgsArrayCodec = t.array(BatchAddUserDataTypeArgsCodec)
// 验证并解析 JSON 字符串的函数
export function parseAndValidateUserDataArray(
  jsonString: string
): E.Either<t.Errors, BatchAddUserDataTypeArgs[]> {
  try {
    const parsed = JSON.parse(jsonString);
    return BatchAddUserDataTypeArgsArrayCodec.decode(parsed);
  } catch (error) {
    // 处理 JSON 解析错误
    return E.left([{
      value: jsonString,
      context: [],
      message: error instanceof Error ? error.message : 'Invalid JSON string'
    }])
  }
}